export enum CharacterAnimations {
  ENCOURAGE = 'encourage',
  IDLE_1 = 'idle1',
  IDLE_2 = 'idle2',
  WIN = 'win',
  LOSE = 'lose',
  SLEEPY = 'sleepy',
  WAKE_UP = 'wakeUp',
  YAWN_TO_SLEEPY = 'sleepyIn',
}

export const CHARACTER_ANIMATION_JSON = '/animation/leprechaunAnim.json';
export const CHARACTER_ANIMATION_ATLAS = '/animation/leprechaunAnim.atlas';
